/**
 * 入口
 */
import Vue from 'vue';
import Main from './components/index/index.vue';
import axios from 'axios';
import VueLazyload from 'vue-lazyload';

window.axios = axios;

Vue.use(VueLazyload);

new Vue({
    el: '#app',
    components: {
        'bcm-main': Main
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/web/index.js